import { Badge } from "@/components/ui/badge";

import { voiceAIOutreachStatusToLabel } from "@/lib/constants";
import { VoiceAIOutreachStatus } from "@/types";

export const StatusBadge = ({ status }: { status: VoiceAIOutreachStatus }) => {
  const label = voiceAIOutreachStatusToLabel[status];

  /* Render */
  const render = () => {
    switch (status) {
      case VoiceAIOutreachStatus.COMPLETED:
      case VoiceAIOutreachStatus.IN_PROGRESS:
        return (
          <Badge variant="secondary" className="bg-green-100 text-green-700">
            {label}
          </Badge>
        );
      case VoiceAIOutreachStatus.CANCELLED:
      case VoiceAIOutreachStatus.FAILED:
        return (
          <Badge variant="secondary" className="bg-red-100 text-red-700">
            {label}
          </Badge>
        );
      case VoiceAIOutreachStatus.VOICEMAIL:
        return (
          <Badge variant="secondary" className="bg-blue-100 text-blue-700">
            {label}
          </Badge>
        );
      default:
        return (
          <Badge variant="secondary" className="bg-slate-100 text-slate-700">
            {label}
          </Badge>
        );
    }
  };

  return render();
};
